/* eslint-disable react/jsx-no-constructed-context-values */
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import {
  RiHome7Line,
  RiHome7Fill,
  RiSearchLine,
  RiSearchFill,
  RiNotificationLine,
  RiNotificationFill,
  RiMailLine,
  RiMailFill,
} from 'react-icons/ri';

import { IconContext } from 'react-icons';

import useNotifications from '../../hooks/useNotifications';
import {
  refreshNavigationTarget,
  scrollAppToTop,
} from '../../utils/navigation-refresh';

const BottomNav = () => {
  const notificationData = useNotifications();
  const location = useLocation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const isHomeActive = location.pathname === '/home';

  const handleHomeNavigation = () => {
    scrollAppToTop();
    queryClient.removeQueries(['posts', 'feed']);
    queryClient.invalidateQueries(['posts', 'feed']);
    navigate('/home', {
      state: {
        openFeedTab: 'for-you',
        homeNavigationAt: Date.now(),
      },
    });
  };

  const handleRefreshableNavigation = ({ event, isActive, queryKeys, to }) => {
    refreshNavigationTarget({
      event,
      isActive,
      navigate,
      queryClient,
      queryKeys,
      to,
    });
  };

  return (
    <div className="flex bg-surface justify-between items-center px-8 h-14 border-t border-on-surface/20">
      <div className="text-on-surface">
        <button type="button" onClick={handleHomeNavigation} aria-label="Home">
          <IconContext.Provider
            value={{
              size: '24px',
              style: {
                color: 'inherit',
              },
            }}
          >
            {isHomeActive ? <RiHome7Fill /> : <RiHome7Line />}
          </IconContext.Provider>
        </button>
      </div>
      <div className="text-on-surface">
        <NavLink
          to="/search"
          onClick={(event) =>
            handleRefreshableNavigation({
              event,
              isActive: location.pathname === '/search',
              queryKeys: ['search'],
              to: '/search',
            })
          }
        >
          {({ isActive }) => (
            <IconContext.Provider
              value={{
                size: '24px',
                style: {
                  color: 'inherit',
                },
              }}
            >
              {isActive ? <RiSearchFill /> : <RiSearchLine />}
            </IconContext.Provider>
          )}
        </NavLink>
      </div>
      <div className="text-on-surface">
        <NavLink
          to="/notifications"
          onClick={(event) =>
            handleRefreshableNavigation({
              event,
              isActive: location.pathname === '/notifications',
              queryKeys: ['notifications'],
              to: '/notifications',
            })
          }
        >
          {({ isActive }) => (
            <div className="relative">
              <span>
                <IconContext.Provider
                  value={{
                    size: '24px',
                    style: {
                      color: 'inherit',
                    },
                  }}
                >
                  {isActive ? <RiNotificationFill /> : <RiNotificationLine />}
                </IconContext.Provider>
              </span>
              {notificationData.isSuccess &&
                notificationData.data.pages[0].info.unReadNotifications > 0 && (
                  <span className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-primary flex items-center justify-center text-xs">
                    <span>
                      {notificationData.data.pages[0].info.unReadNotifications}
                    </span>
                  </span>
                )}
            </div>
          )}
        </NavLink>
      </div>
      <div className="text-on-surface">
        <NavLink
          to="/messages"
          onClick={(event) =>
            handleRefreshableNavigation({
              event,
              isActive: location.pathname.startsWith('/messages'),
              queryKeys: ['messages'],
              to: '/messages',
            })
          }
        >
          {({ isActive }) => (
            <IconContext.Provider
              value={{
                size: '24px',
                style: {
                  color: 'inherit',
                },
              }}
            >
              {isActive ? <RiMailFill /> : <RiMailLine />}
            </IconContext.Provider>
          )}
        </NavLink>
      </div>
    </div>
  );
};

export default BottomNav;
